import { Button } from "@/components/ui/Button";

interface SkipSheetProps {
  readonly open: boolean;
  readonly onKeep: () => void;
  readonly onSkipAnyway: () => void;
}

/** Bottom-sheet warning shown before the user bails out of personalisation. */
export function SkipSheet({ open, onKeep, onSkipAnyway }: SkipSheetProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center" role="dialog" aria-modal="true"
      aria-label="Skip personalisation?">
      <button
        type="button"
        aria-label="Dismiss"
        onClick={onKeep}
        className="absolute inset-0 bg-black/40"
      />
      <div className="ob-sheet-up relative w-full max-w-xl rounded-t-3xl border-t border-border bg-surface px-6 pb-[max(env(safe-area-inset-bottom),2rem)] pt-6">
        <h2 className="text-xl font-bold text-text">Skip personalisation?</h2>
        <p className="mt-2 text-sm leading-relaxed text-text-muted">
          Your plan works best when it's tailored to you. Skipping means generic calorie targets
          and no custom timeline.
        </p>
        <div className="mt-6 flex flex-col gap-3">
          <Button variant="primary" size="lg" className="w-full" onClick={onKeep}>
            Keep personalising
          </Button>
          <button
            type="button"
            onClick={onSkipAnyway}
            className="min-h-[44px] select-none text-sm font-medium text-text-muted transition-opacity active:opacity-80"
          >
            Skip anyway
          </button>
        </div>
      </div>
    </div>
  );
}
